import React, { Component } from 'react'
import axios from 'axios'
import { APIURL, IMAGE_NOPHOTO_URL, IMAGE_UPLOAD_ERROR } from '../../../config/config'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import DatePicker from 'react-datepicker'
import CarBookForm from '../CarBookForm/CarBookForm'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import { connect } from 'react-redux'
import ThaiBaht from 'thai-baht-text'
import NumberFormat from 'react-number-format'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { AlertWarning } from '../../Alert/Alert'
import PreviewImage from '../../../views/PreviewImage'
import { NumberUtil } from '../../../utils/number-util'
import parse from 'html-react-parser'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew-Regular.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

const port = window.env.PORT;

class CarBook extends Component{
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            lists: [],
            load_data: true,
            danger: false,
            refund:false,
            car: '',
            car_id:'',
            customer_id:'',
            customer: {},
            customer_select:false,
            toggle_bill_print: false,
            customer_list: [],
            car_sell_pay:[],
            car_book_list:[],
            car_book_id: '',
            car_sell_id:'',
            bank:[],
            car_status:[],
            sales_type:[],
            person_transaction:'',
            startDatePay: moment(),
            carbookprimary: false,
            car_sell_pay_id:0,
            car_sell_pay_count:0,
            car_book_refund: 0,
            car_sell_pay_selected: {},
            book_status: 'add',
          // add payment
          toggle_add_payment: false,
          date_pay: new Date(),
          car_sell_list_pay: [],
          car_sell_list_pay_id: 0,
          // sales_type: [],
          // bank: [],
          sales_type_id: 0,
          car_sell_pay_add: {},
          carBase64Img: '',
          width: 0,
          height: 0,
          toggle_slip: false,
          slip_image1: IMAGE_NOPHOTO_URL,
          slip_image2: IMAGE_NOPHOTO_URL,
          slip_key1: '',
          slip_key2: '',
          preview_image_url: '',
          preview_image_select: false,
          company_setting: null,
          logoBase64Img: '',
          book_number: '',
          volume_number: ''
       };

      this.saveBookNumber = this.saveBookNumber.bind(this);
      this.updateBookNumber = this.updateBookNumber.bind(this);
      this.handleDatePay = this.handleDatePay.bind(this);
      this.printOcpb = this.printOcpb.bind(this);
      this.toggleCarBookPrimary= this.toggleCarBookPrimary.bind(this);
      this.loadCarBook = this.loadCarBook.bind(this);
      this.togglePrintBill = this.togglePrintBill.bind(this);
      this.printCarBook = this.printCarBook.bind(this);
      this.printCarBookPdf = this.printCarBookPdf.bind(this);
      //
      this.handleDatePayAdd = this.handleDatePayAdd.bind(this);
      this.toggleAddPayment = this.toggleAddPayment.bind(this);
      this.handleCarSellPayAddSubmit = this.handleCarSellPayAddSubmit.bind(this);
      this.makeCarImgBase64 = this.makeCarImgBase64.bind(this);
      this.loadCarImageBase64 = this.loadCarImageBase64.bind(this);
      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      // add slip
      this.toggleSlip = this.toggleSlip.bind(this);
      this.saveCarImage = this.saveCarImage.bind(this);
      this.handleUploadFile = this.handleUploadFile.bind(this);
      this.onPreviewSelected = this.onPreviewSelected.bind(this);
      this.togglePreviewImage = this.togglePreviewImage.bind(this);
      //
      this.loadCompanySetting = this.loadCompanySetting.bind(this);
      this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
      this.carBookCancel = this.carBookCancel.bind(this);
  }

  handleDatePay (date) {
    this.setState({
      startDatePay: new Date(date)
    })
  }

  handleDatePayAdd(date) {
    this.setState({
      date_pay: new Date(date)
    })
  }

  togglePrintBill(){
        this.setState({
            toggle_bill_print: !this.state.toggle_bill_print
        })
  }

  toggleSlip(){
    this.setState({
      toggle_slip: !this.state.toggle_slip
    })
  }

  saveCarImage(e,urlImage){
    e.preventDefault();
    let a = document.createElement('a');
    a.href = urlImage;
    a.target = '_blank';
    a.download = urlImage;
    a.click();
    a.remove();
    return false;
  }

  formatDate (date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  printOcpb (car_sell_pay) {
    const car_book_id = car_sell_pay.car_book_id;

    let car_brance = ''
    let car_brance_address = ''
    let car_brance_tel = ''
    let tax_id = this.state.company_setting.juristic_number

    if (port === 9027) {
      // mktent ที่อยู่สาขาตาม user ที่จอง
      car_brance = car_sell_pay.branch_name
      car_brance_address = car_sell_pay.branch_address
      car_brance_tel = car_sell_pay.branch_tel

    } else if (Number(port) === 9008) {
      // ชื่อตาม company setting ทุกสาขา
      let company_name = this.state.company_setting.company_name
      car_brance = company_name
      car_brance_address = this.state.car.branch_address
      car_brance_tel = this.state.car.branch_tel
    } else {
      // ที่อยู่ตามรถ
      car_brance = this.state.car.branch_name
      car_brance_address = this.state.car.branch_address
      car_brance_tel = this.state.car.branch_tel
    }

    console.log('tax_id=', tax_id , typeof tax_id)

    const car_name = this.state.car.car_name //ยี่ห้อรถ
    const car_color_name = this.state.car.car_color_name //สี
    const car_license_plate_new = this.state.car.car_license_plate_new //ทะเบียนรถยนต์
    const car_province_name_new = this.state.car.province_name_new//จังหวัด

    const customer_name = car_sell_pay.customer_name //ชื่อลูกค้า
    const customer_lastname = car_sell_pay.customer_lastname //นามสกุลลูกค้า
    const customer_address = car_sell_pay.customer_address //ที่อยู่ลูกค้า
    const customer_mobile = car_sell_pay.customer_mobile //
    const date_pay = moment(car_sell_pay.date_pay).locale('th').format('LL') //วันที่ออกใบเสร็จหรือวันที่จ่าย
    // const person_transaction = car_sell_pay.person_transaction //ผู้ออกใบเสร็จ
    // let person_transaction = ''
    const person_transaction = car_sell_pay.booking_by === null ? car_sell_pay.book_by : car_sell_pay.booking_by //ผู้รับจอง
    // if(Number(port) === 9008) {
    //    person_transaction = car_sell_pay.booking_by === null ? car_sell_pay.book_by : car_sell_pay.booking_by //ผู้รับจอง
    // }else {
    //    person_transaction = car_sell_pay.book_by //ผู้ออกใบเสร็จ
    // }
    const car_sell_list_pay = car_sell_pay.car_sell_list_pay_name //รายการที่จ่าย
    const sales_type = car_sell_pay.sales_type_name //รูปแบบการจ่าย
    const car_sell_pay_count = '฿' + car_sell_pay.car_sell_pay_count.toLocaleString()  //ยอดเงินจอง

    let bill_no = 'R'+car_book_id //this.refs.bill_no.value

    const book_number = car_sell_pay.book_number //
    const volume_number = car_sell_pay.volume_number === '' ? '-' : String(car_sell_pay.volume_number) //

    if (book_number !== '' && book_number !== null) {
      bill_no = book_number
    }

    let car_note =  ' ' // car_sell_pay.car_sell_pay_count>=3000? '***ลูกค้ารับแหวนทองแล้ว' : ' ';

    let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)
    let businessCol = []
    if (tax_id !== '0000000000000' && tax_id !== null) {
      // แสดงเลขที่ผู้เสียภาษี
      businessCol = {
        columns: [
          {
            width: '20%',
            text: 'ผู้ประกอบธุรกิจ', style: 'bodycompany'
          },
          {
            width: '40%', style: 'bodycompany',
            text: car_brance,
          },
          {
            width: '20%',
            text: 'เลขที่ผู้เสียภาษี', style: 'bodycompany'
          },
          {
            width: '40%', style: 'bodycompany',
            text: tax_id,
          },
        ],
        columnGap: 20,
        lineHeight: 1
      }
    } else {
      // ไม่แสดงเลขที่ผู้เสียภาษี
      businessCol = {
        columns: [
          {
            width: '20%',
            text: 'ผู้ประกอบธุรกิจ', style: 'bodycompany'
          },
          {
            width: '80%', style: 'bodycompany',
            text: car_brance,
          },
        ],
        columnGap: 20,
        lineHeight: 1
      }
    }

    console.log()
    // const carDetail2 = JSON.parse(JSON.stringify(carDetail));
    let businessCol2 =  JSON.parse(JSON.stringify(businessCol));


    const docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [25, 30, 25, 0],
      background: {image: 'book', width: 600},

      content: [
        {text: 'ใบเสร็จรับเงิน', style: 'bodyhead', lineHeight: 1.3},
        {
          columns: [
            {
              width: '20%',
              text: ' ', style: 'bodycompany'
            },
            {
              width: '46%', style: 'bodycompany',
              text: ' ',
            },
            {
              width: '5%',
              text: 'เล่มที่', style: 'bodycompany'
            },
            {
              width: '6%', style: 'bodycompany',
              text: volume_number,
            },
            {
              width: '5%',
              text: 'เลขที่', style: 'bodycompany'
            },
            {
              width: '18%', style: 'bodycompany',
              text: bill_no,
            },
          ],
          columnGap: 20,
          lineHeight: 1
        },
        {
          columns: [
            {
              width: '20%',
              text: '', style: 'bodycompany'
            },
            {
              width: '40%', style: 'bodycompany',
              text: '',
            },
            {
              width: '20%',
              text: 'วันที่ออกใบเสร็จ', style: 'bodycompany'
            },
            {
              width: '20%', style: 'bodycompany',
              text: date_pay,
            },

          ],
          columnGap: 20,
          lineHeight: 1
        },
        businessCol,
        {
          columns: [
            {
              width: '19%',
              text: 'สถานที่ประกอบการ', style: 'bodycompany'
            },
            {
              width: '81%', style: 'bodycompany',
              text: car_brance_address,
            },

          ],
          columnGap: 20,
          lineHeight: 1
        },
        {
          columns: [

            {
              width: '20%',
              text: 'เบอร์โทรศัพท์', style: 'bodycompany'
            },
            {
              width: '40%', style: 'bodycompany',
              text: car_brance_tel,
            },
            {
              width: '20%',
              text: 'ผู้รับจอง(เซลล์)', style: 'bodycompany'
            },
            {
              width: '40%', style: 'bodycompany',
              text: person_transaction,
            },

          ],
            columnGap: 20,
            lineHeight: 1.3
        },

        {
          columns: [
            {
              width: '20%',
              text: 'ชื่อ - นามสกุลลูกค้า', style: 'bodycompany'
            },
            {
              width: '40%', style: 'bodycompany',
              text: customer_name + '   ' + customer_lastname,
            },
            {
              width: '20%',
              text: 'เบอร์โทรศัพท์', style: 'bodycompany'
            },
            {
              width: '40%', style: 'bodycompany',
              text: customer_mobile,
            },

          ],

          columnGap: 20,
          lineHeight: 1.2
        },

        {
          columns: [
            {
              width: '20%',
              text: 'ที่อยู่', style: 'bodycompany'
            },
            {
              width: '80%', style: 'bodycompany',
              text: customer_address,
            },

          ],

          columnGap: 20,
          lineHeight: 1.2
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 2,
            widths: [40, 'auto', 100, 100],
            heights: [20, 20],

            body: [
              [{text: 'ลำดับ', style: 'myCell'},
                {text: 'รายการ', style: 'myCell'},
                {text: 'ราคา/หน่วย', style: 'myCell'},
                {text: 'รวมราคา', style: 'myCell'}],
              [{text: '1', style: 'myCellDetail'},
                {
                  text: car_sell_list_pay + '   ' + car_name + '   '
                  + 'สี' + car_color_name
                  + '  ทะเบียนรถ  ' +  car_license_plate_new + ' '
                  + '   ' + car_province_name_new
                  + '  รูปแบบการชำระเงิน  :  ' + sales_type + ' '
                  + car_note
                  , style: 'body'
                },
                {text: car_sell_pay_count, style: 'myCellPrice'},
                {text: car_sell_pay_count, style: 'myCellSumPrice'}],
            ]
          },

          columnGap: 20,
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ['*', 100],
            heights: [20],

            body: [
              [{text: 'รวมราคา', style: 'myCellSumText'}, {
                text: car_sell_pay_count,
                style: 'myCellSumCost'
              }],
            ]
          },

          columnGap: 20,
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ['*', 100],
            heights: [20],

            body: [
              [{
                text: 'รวมราคาทั้งสิ้น   '  + moneyText,
                style: 'myCellSumTextCost'
              }, {text: car_sell_pay_count, style: 'myCellSumTextCostNum'}],
            ]
          },

          columnGap: 20,
          lineHeight: 1
        },

        {
          columns: [
            {
              width: '100%',
              text: 'หมายเหตุ : หากยกเลิกหรือติดแบล็คลิสต์ไม่คืนมัดจำ',
              style: 'textNote', margin: [0, 3, 0, 0],
            },
          ],
          columnGap: 0,
          lineHeight:1,
        },

        [
          {text: '   '}, {text: '   '}, {text: '   '}, {text: '   '}, {text: '   '},{text: '   '},/*{text: '   '},*/
          {text: 'ใบเสร็จรับเงิน', style: 'bodyhead', lineHeight: 1.3},
          {
            columns: [
              {
                width: '20%',
                text: '', style: 'bodycompany'
              },
              {
                width: '46%', style: 'bodycompany',
                text: '',
              },
              {
                width: '5%',
                text: 'เล่มที่', style: 'bodycompany'
              },
              {
                width: '6%', style: 'bodycompany',
                text: volume_number,
              },
              {
                width: '5%',
                text: 'เลขที่', style: 'bodycompany'
              },
              {
                width: '18%', style: 'bodycompany',
                text: bill_no,
              },
            ],

            columnGap: 20,
            lineHeight: 1
          },
          {
            columns: [
              {
                width: '20%',
                text: '', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: '',
              },
              {
                width: '20%',
                text: 'วันที่ออกใบเสร็จ', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: date_pay,
              },

            ],
            columnGap: 20,
            lineHeight: 1
          },
          businessCol2,
          {
            columns: [
              {
                width: '19%',
                text: 'สถานที่ประกอบการ', style: 'bodycompany'
              },
              {
                width: '81%', style: 'bodycompany',
                text: car_brance_address,
              },

            ],
            columnGap: 20,
            lineHeight: 1
          },

          {
            columns: [

              {
                width: '20%',
                text: 'เบอร์โทรศัพท์', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: car_brance_tel,
              },
              {
                width: '20%',
                text: 'ผู้รับจอง(เซลล์)', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: person_transaction,
              },

            ],

            columnGap: 20,
            lineHeight: 1.3
          },

          {
            columns: [
              {
                width: '20%',
                text: 'ชื่อ - นามสกุลลูกค้า', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: customer_name + '   ' + customer_lastname,
              },
              {
                width: '20%',
                text: 'เบอร์โทรศัพท์', style: 'bodycompany'
              },
              {
                width: '40%', style: 'bodycompany',
                text: customer_mobile,
              },

            ],

            columnGap: 20,
            lineHeight: 1.2
          },

          {
            columns: [
              {
                width: '19%',
                text: 'ที่อยู่', style: 'bodycompany'
              },
              {
                width: '80%', style: 'bodycompany',
                text: customer_address,
              },

            ],

            columnGap: 20,
            lineHeight: 1.2
          },

          {
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 2,
              widths: [40, 'auto', 100, 100],
              heights: [20, 20],

              body: [
                [{text: 'ลำดับ', style: 'myCell'},
                  {text: 'รายการ', style: 'myCell'},
                  {text: 'ราคา/หน่วย', style: 'myCell'},
                  {text: 'รวมราคา', style: 'myCell'}],
                [{text: '1', style: 'myCellDetail'},
                  {
                    text: car_sell_list_pay + '   '
                    + car_name + '   '
                    + 'สี' + car_color_name + ' '
                    + '   '
                    + 'ทะเบียนรถ   '  + car_license_plate_new+ ' '
                    + '   ' + car_province_name_new
                    + '   รูปแบบการชำระเงิน  :  ' + sales_type+ ' '
                    + car_note
                    , style: 'body'
                  },
                  {text: car_sell_pay_count, style: 'myCellPrice'},
                  {text: car_sell_pay_count, style: 'myCellSumPrice'}],
              ]
            },

            columnGap: 20,
          },

          {
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: ['*', 100],
              heights: [20],

              body: [
                [{text: 'รวมราคา', style: 'myCellSumText'}, {
                  text: car_sell_pay_count,
                  style: 'myCellSumCost'
                }],
              ]
            },

            columnGap: 20,
          },

          {
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: ['*', 100],
              heights: [20],
              body: [
                [{
                  text: 'รวมราคาทั้งสิ้น   ' + moneyText,
                  style: 'myCellSumTextCost'
                }, {text: car_sell_pay_count, style: 'myCellSumTextCostNum'}],
              ]
            },

            columnGap: 20,
            lineHeight: 1
          },

          {
            columns: [
              {
                width: '100%',
                text: 'หมายเหตุ : หากยกเลิกหรือติดแบล็คลิสต์ไม่คืนมัดจำ',
                style: 'textNote', margin: [0, 3, 0, 0]
              },
            ],
            columnGap: 0,
            lineHeight:1,
          },

        ],

      ],

      images: {
        book: 'data:image/png;base64,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'
      },

      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 14,
          fillColor: '#BEBEBE',
          alignment: 'center',
          bold: true,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: 'center',
        },
        myCellPrice: {
          fontSize: 14,
          alignment: 'right',
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: 'right',
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: '#D3D3D3',
          alignment: 'left',
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: '#D3D3D3',
          alignment: 'right',
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: '#FF9933',
          alignment: 'left',
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: '#FF9933',
          alignment: 'right',
          bold: true,
        },
        textNote: {
          fontSize: 14,
          color : '#ff0000'
        },
      },

      defaultStyle: {
        font: 'THSarabunNew'
      }
    }
    pdfMake.createPdf(docDefinition).open()
  }

  handleOnSubmitCarBook (event) {
    event.preventDefault()
    if (this.state.car_sell_pay.length === 0) {
      alert('กรุณากรอกข้อมูลการชำระเงิน')
      return
    }
    let that = this
    let car_id = this.state.car_id
    let customer_id = this.state.customer_id
    let car_book_status_id = 1

    axios.post(APIURL + '/car_book/', {
      car_id: car_id,
      customer_id: customer_id,
      car_book_status_id: car_book_status_id,
      user_created: this.state.user.user,
      user_updated: this.state.user.user
    })
      .then(response => {
        //console.log(response)
        //alert(response.data)
        that.props.history.push('/cars/list')
        //}
        //this.setState({ car: '', car_id: 0, action: "บันทึก"})
      })
      .catch(function (error) {
        console.log(error)
        //alert("error"+error)
      })
  }

  loadCarById () {
    // var that = this
    axios.get(APIURL + '/car/' + this.state.car_id)
      .then(async res => {
        let car = res.data[0]
        this.setState({
          car: car
        }, async () => {
          await this.makeCarImgBase64()
        })
      }).catch(error => {
      // alert('error' + error)
      console.log('error:', error)
      this.setState({car: {}})
    })
  }

  async makeCarImgBase64() {
    try {
      let car = this.state.car
      await this.loadCarImageBase64(car.car_upload_id)
    } catch (e) {
      // console.log('----makeCarImgBase64 error')
      console.log(e)
    }
  }

  async loadCarImageBase64(car_upload_id) {
    let uri =  APIURL + '/car/image/' + car_upload_id;
    await axios.get(uri)
      .then(res => {
        let body = res.data.body
        // console.log(res.data)
        this.setState({ carBase64Img: body })
      }).catch(error => {
        console.log('error:', error)
      })
  }

  loadCarBook () {

    if (this.state.car_id === '') {
      return
    }

    let api_url = APIURL + '/car_book/' + this.state.car_id
    axios.get(api_url)
      .then(res => {
        this.setState({car_book_list: res.data})
      }).catch(error => {
      alert('พอข้อผิดพลาด: ' + error.message)
      this.setState({car_book_list: []})
    })
  }

  componentWillMount () {
    //const queryString = require('query-string');
    this.setState({
      user: JSON.parse(this.props.user),
    })
  }

  componentDidMount () {
    // if(this.state.load_data)
    // this.loadDebtorsData()
    const queryString = require('query-string')
    let car = queryString.parse(this.props.location.search)

    this.setState({car_id: car.car_id}, () => {
      this.loadCompanyLogoBase64();
      this.loadCompanySetting();
      this.loadCarById();
      this.loadCarBook();
    })

    // 9008

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  loadCompanySetting () {
    axios.get(APIURL + '/company_setting/1')
      .then(res => {
        let data = res.data
        let company_setting = data.company_setting
        if (company_setting !== null) {
          this.setState({ company_setting: company_setting })
        }
      })
  }

  loadCompanyLogoBase64() {
    let uri =  APIURL + '/company_setting/logoimage/1';
    // console.log('uri=', uri)
    axios.get(uri)
      .then(res => {
        let body = res.data.body
        // console.log('----loadCompanyLogoBase64')
        // console.log(body)
        this.setState({ logoBase64Img: body })
      }).catch(error => {
        console.log('error: ', error)
      })
  }


  refundCarBook (car_sell_pay) {
    //alert(car_sell_pay.car_book_id )
    this.setState({
      car_sell_pay_id: car_sell_pay.car_sell_pay_id,
      car_sell_pay_count: car_sell_pay.car_sell_pay_count,
      car_sell_pay_selected: car_sell_pay
    }, () => {
      this.toggleRefund()
    })

  }

  toggleRefund () {
    this.setState({
      refund: !this.state.refund
    })
  }

  toggleCarBookPrimary () {
    this.setState({
      carbookprimary: !this.state.carbookprimary
    })
  }

  deleteCarBook (car_sell_pay) {
    //alert(car_sell_pay.car_book_id )
    this.setState({
      car_book_id: car_sell_pay.car_book_id,
      car_sell_pay_id: car_sell_pay.car_sell_pay_id,
      car_sell_pay_selected: car_sell_pay
    }, () => {
      this.toggleDanger()
    })

  }

  // ลบการจ่ายเงินเพิ่มเติม
  deleteCarBookPayAddition(car_sell_pay) {
      let car_sell_pay_count = car_sell_pay.car_sell_pay_count
      if(window.confirm('ยืนยันการลบรายการ ยอด '+car_sell_pay_count.toLocaleString()+' บาท')) {
        let car_sell_pay_id = car_sell_pay.car_sell_pay_id
        axios.delete(APIURL+'/car_sell_pay/'+car_sell_pay_id)
          .then(res => {
            console.log(res)
            this.loadCarBook()
          })
      }
  }

  toggleDanger () {
    this.setState({
      danger: !this.state.danger
    })
  }

  carBookCancel (car_book_id) {
    var book_rows = 0
    // eslint-disable-next-line
    this.state.car_book_list.map((car_sell_pay, index) => {
      if (car_sell_pay.car_book_status_id === 1) { // 1 = จอง 2= ยกเลิก
        book_rows++
      }
    })

    // TODO: xxxx ยกเลิกการจอง
    // var book_rows = this.state.car_book_list.length
    let url = APIURL + '/car_book/cancel/' + car_book_id
    if (port === 9021 ||  port === '9021') {
      // 9021 sompong
      url = APIURL + '/car_book/cancel2/' + car_book_id
    }

    // console.log('url=', url)
    // return

    axios.put(url, {
      book_rows: book_rows,
      car_id: this.state.car_id,
      car_sell_pay_id: this.state.car_sell_pay_id
    }).then(res => {
      if (res.status === 200) {
        this.loadCarBook()
        this.toggleDanger()
        //this.setState({action: "บันทึก"});
      }
    }).catch(error => {
      alert('พอข้อผิดพลาด: ' + error.message)
    })
  }

  carBookCancelRefund () {
    var book_rows = 0
    var car_id = this.state.car_id
    var car_sell_pay_id = this.state.car_sell_pay_id
    var car_sell_pay_count = this.state.car_sell_pay_count
    var car_book_id = this.state.car_sell_pay_selected.car_book_id
    var car_book_refund = this.state.car_book_refund

    // eslint-disable-next-line
    this.state.car_book_list.map((car_sell_pay, index) => {
      if (car_sell_pay.car_book_status_id === 1) {
        book_rows++
      }
    })

    // alert(car_book_refund)

    if (car_book_refund === 0) {
      alert('กรุณากรอกยอดคืนเงิน')
      return
    }

    if (car_book_refund > car_sell_pay_count) {
      alert('ยอดเงินคืนมากกว่ายอดชำระ กรุณาตรวจสอบ')
      return
    }

    // alert("car_sell_pay_id="+car_sell_pay_id)
    // return ;

    axios.put(APIURL + '/car_book/cancel/refund/' + car_book_id, {
      book_rows: book_rows,
      car_id: car_id,
      car_book_id: car_book_id,
      car_sell_pay_id: car_sell_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      car_book_refund: car_book_refund
    }).then(res => {
      if (res.status === 200) {
        this.loadCarBook()
        this.toggleRefund()
        //this.setState({action: "บันทึก"});
      }
    }).catch(error => {
      alert('พอข้อผิดพลาด: ' + error.message)
    })
  }

  async printCarBook(car_sell_pay) {
      var car_id = car_sell_pay.car_id
      var customer_id = car_sell_pay.customer_id
      var car_book_id = car_sell_pay.car_book_id
      var car = this.state.car ;
      var carLeasingList = [];
      var profile = {};
      var carBook = {};

      if (this.state.carBase64Img === '') {
        await this.makeCarImgBase64()
      }

      //load car_leasing
       var uri =  APIURL + '/car_leasing/'+car_id;
       await axios.get(uri)
        .then(res => {
           return carLeasingList = res.data
        }).catch(error => {
          carLeasingList = []
           return null;
       })

      await axios.get(APIURL + '/profile/customer/'+customer_id)
        .then(res => {
          if(res.data.length > 0) {
            // console.log(res.data[0])
            return profile = res.data[0];
          }
        }).catch(error => {
          profile = {}
          return null;
      })

      await axios.get(APIURL + '/car_book/book/'+car_book_id)
      .then(res => {
        if(res.data.length > 0) {
          return carBook = res.data[0];
        }
      }).catch(error => {
        carBook = {}
        return null;
      })

      await this.printCarBookPdf(car_sell_pay, car, carLeasingList, carBook, profile);

  }


  async printCarBookCustomer(car_sell_pay) {
    let car_id = car_sell_pay.car_id
    let customer_id = car_sell_pay.customer_id
    let car_book_id = car_sell_pay.car_book_id
    let car = this.state.car ;
    let carLeasingList = [];
    let profile = {};
    let carBook = {};
    let customer = {};

    if (this.state.logoBase64Img === '') {
      // await this.makeCarImgBase64()
      console.log('no logoBase64Img');
      AlertWarning('ไม่พบไฟล์ logo');
    }

    // load car_leasing
    let uri =  APIURL + '/car_leasing/'+car_id;

    await axios.get(uri)
      .then(res => {
        return carLeasingList = res.data
      }).catch(error => {
        carLeasingList = []
        return null;
      })

    await axios.get(APIURL + '/profile/customer/'+customer_id)
      .then(res => {
        if(res.data.length > 0) {
          return profile = res.data[0];
        }
      }).catch(error => {
        profile = {}
        return null;
      })

    await axios.get(APIURL + '/car_book/book/'+car_book_id)
      .then(res => {
        if(res.data.length > 0) {
          return carBook = res.data[0];
        }
      }).catch(error => {
        carBook = {}
        return null;
      })

    await axios.get(APIURL + '/customer/' + customer_id)
      .then(res => {
        if(res.data.length > 0) {
          // this.setState({customer: res.data[0]})
          // console.log('===getDataCustomerById')
          return customer = res.data;
        }
        //alert (res.data)
      }).catch(error => {
        customer = {}
        return null;
    })

    await this.printCarBookPdfCustomer(car_sell_pay, car, carLeasingList, carBook, profile, customer);

  }

  printCarBookPdfCustomer(car_sell_pay, car, carLeasingList, carBook, profile, customers){
    const {
      company_setting,
    } = this.state

    const book_date = moment(carBook.book_date).locale('th').format('LL') //วันที่ออกใบเสร็จหรือวันที่จ่าย

    let customer = customers[0]
    const customer_id = customer.customer_id
    const tax_invoice_name = customer.customer_name+' '+ customer.customer_lastname
    const tax_invoice_address1 = customer.customer_address
    const tax_invoice_address2 = ''
    let tax_invoice_tax_id = customer.customer_card_id === null ? '' : customer.customer_card_id
    const customer_mobile = customer.customer_mobile //

    // n.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
    if (tax_invoice_tax_id.length===13) {
      tax_invoice_tax_id = tax_invoice_tax_id.replace(/(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/, "$1-$2-$3-$4-$5")
    }

    const car_name = car.car_name //ยี่ห้อรถ
    // const car_color_name = this.state.car.car_color_name //สี
    const car_license_plate_new = car.car_license_plate_new === '' || car.car_license_plate_new === null ? car.car_license_plate_old: car.car_license_plate_new // ทะเบียนรถยนต์
    const car_province_name_new = car.car_license_plate_new === '' || car.car_license_plate_new === null ?  car.province_name_old : car.car_license_plate_new // จังหวัด
    const car_color_name = car.car_color_name
    // const car_explain = car.car_explain
    // const car_sale_price = car.car_sale_price.toLocaleString()
    // const customer_name = car_sell_pay.customer_name //ชื่อลูกค้า
    // const customer_lastname = car_sell_pay.customer_lastname //นามสกุลลูกค้า
    // const customer_address = car_sell_pay.customer_address //ที่อยู่ลูกค้า

    // ข้อมูลการจอง
    const cost_car_book = carBook.cost_car_book.toFixed(2).toString()
    const cost_pledge = carBook.cost_pledge.toFixed(2).toString()
    const cost_car_book_bath = ThaiBaht(cost_car_book)
    const cost_pledge_bath = ThaiBaht(cost_pledge)
    const sales_type_name = car_sell_pay.sales_type_name

    let base64Img = this.state.logoBase64Img
    let company_name = company_setting.company_name
    let company_address = ''
    let company_address_all = company_setting.company_address

    // อำเภอ
    let company_arr = company_address_all.split('อำเภอ')
    if (company_arr.length === 2) {
      let company_arr1 = company_arr[0]
      let company_arr2 = company_arr[1]
      company_address = company_arr1 +'\nอำเภอ'+ company_arr2
    } else {
      company_address = company_address_all
    }

    let juristic_number = company_setting.juristic_number
    let company_tel = company_setting.company_tel === '' ? '-' : company_setting.company_tel

    // vat
    // is_vat vat
    let is_vat = company_setting.is_vat
    let vat = parseFloat(company_setting.vat)

   let price_data = []
   let price_sale = {
      columns: [
        { width: '15%',
          text: 'ราคาเงินสด', style: 'normal',
        },
        { width: '25%',
          text: NumberUtil.addCommas(cost_car_book)+'  บาท', style: 'normalRight',
        },
        { width: '60%',
          text: '', style: 'normal',
        },
      ],
      columnGap: 0,
      lineHeight:1.2
    }

    price_data.push(price_sale)

    if (is_vat === 1) {
      let price_sale = parseFloat(carBook.cost_car_book)
      let vat_amount = parseFloat(price_sale * (vat/100)).toFixed(2)
      let tmp_net_sale = parseFloat(price_sale) + parseFloat(vat_amount)

      // console.log('price_sale=', price_sale)
      // console.log('vat_amount=', vat_amount)
      // console.log('tmp_net_sale=', tmp_net_sale)

      let net_sale = tmp_net_sale.toFixed(2).toString()
      // const vat_bath = ThaiBaht(vat_amount)
      const net_sale_bath = ThaiBaht(net_sale)
        // carBook.cost_pledge.toFixed(2).toString()

      let price_vat = {
        columns: [
          { width: '15%',
            text: 'ภาษามูลค่าเพิ่ม', style: 'normal',
          },
          { width: '25%',
            text: NumberUtil.addCommas(vat_amount)+'  บาท', style: 'normalRight',
          },
          { width: '60%',
            text: '', style: 'normal',
          },
        ],
        columnGap: 0,
        lineHeight:1.2
      }
      let price_net = {
        columns: [
          { width: '15%',
            text: 'รวมทั้งหมด', style: 'normal',
          },
          { width: '25%',
            text: NumberUtil.addCommas(net_sale)+'  บาท', style: 'normalRight',
          },
          { width: '1%',
            text: '', style: 'normal',
          },
          { width: '59%',
            text: ' ('+net_sale_bath+')', style: 'normal',
          },
        ],
        columnGap: 0,
        lineHeight:1.2
      }

      // price_data.push(price_vat)
      // price_data.push(price_net)

    }

    let docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [35, 25, 35, 25], // margin: [left, top, right, bottom]
      content: [
        {
          table: {
            widths: [ '20%', '60%', '20%' ],
            body: [
              [
                {image: base64Img, width: 120, rowSpan: 3},
                {text: company_name, style: 'bodyhead'},
                {text: ' ', style: 'normalRight', rowSpan: 3},
              ],
              [
                '',
                {text:  company_address , style: 'normalCenter'},
                '',
              ],
              [
                '',
                {text:  '' , style: 'normalCenter'},
                '',
              ],
              [
                {text: '' , style: 'normalCenter'},
                {text: 'ใบรับมัดจำจองสินค้า', style: 'titleLarge', margin: [0, 0, 0, 0]},
                {text: '', style: 'normalRight'},
              ],
              [
                {text: 'วันที่ '+ book_date , style: 'normal', colSpan: 2, margin: [ 0, 8, 0, 8 ]},
                '',
                {text: '', style: 'normalRight'},
              ],
            ],
          },
          layout: 'noBorders'
        },
        {
          columns: [
            { width: '100%',
              text: 'ชื่อผู้ซื้อ...'+tax_invoice_name+'... ที่อยู่...' + tax_invoice_address1+'...', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2,
          margin: [ 0, 0, 0, 0 ]
        },
        {
          columns: [
            { width: '100%',
              text: tax_invoice_address2 + ' เลขบัตรประจำตัวประชาชน...'+ tax_invoice_tax_id + '... โทรศัพท์...' + customer_mobile+'...', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        {
          columns: [
            { width: '100%',
              text: 'ได้ตกลงซื้อสินค้าจาก...'+company_name+'... รายละเอียดดังนี้', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        {
          columns: [
            { width: '100%',
              text: 'รถยนต์...'+car_name+'... สี...'+car_color_name+'... เลขทะเบียน...'+car_license_plate_new+'... จังหวัด...'+car_province_name_new.trim()+'...', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        {
          columns: [
            { width: '100%',
              text: 'ราคาเงินสด...'+NumberUtil.addCommas(cost_car_book)+'...บาท (...'+cost_car_book_bath+'...)', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        {
          columns: [
            { width: '100%',
              text: 'โดยในวันนี้ผู้ซื้อได้ชำระเงินมัดจำไว้เป็นจำนวนเงิน...'+NumberUtil.addCommas(cost_pledge)+'...บาท (...'+cost_pledge_bath+'...) การชำระ...'+sales_type_name+'...', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        {
          columns: [
            { width: '100%',
              text: 'กำหนดรับรถยนต์ภายในวันที่.....................................................................', style: 'normal',
            },
          ],
          columnGap: 0,
          lineHeight:1.2
        },
        /*{
          columns: [
            { width: '15%',
              text: 'ที่อยู่', style: 'normal',
            },
            { width: '85%', style: 'normal',
              text: tax_invoice_address1,
            },
          ],
          columnGap: 0,
          lineHeight:1
        },*/
        {
          columns: [
            { width: '5%',
              text: '', style: 'normal',
            },
            { width: '95%', style: 'normal',
              text: 'หากว่าผู้ซื้อไม่มารับรถยนต์ภายในกำหนด ผู้ซื้อยินยอมให้ผู้ขายริบมัดจำ และหากว่าผู้ขายไม่สามารถโอนกรรมสิทธิ์',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '100%', style: 'normal',
              text: 'ให้กับผู้ซื้อได้ ผู้ขายยินยอมคืนเงินให้ทั้งหมด',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 0, 0, 0 ]
        },
        {
          columns: [
            { width: '50%',
              text: 'เงื่อนไขการชำระ', style: 'bodyhead',
            },
            { width: '50%', style: 'bodyhead',
              text: 'อุปกรณ์เพิ่มเติม',
            },
          ],
          columnGap: 1,
          lineHeight:1,
          margin: [ 0, 16, 0, 4 ]
        },
        {
          columns: [
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
          ],
          columnGap: 1,
          lineHeight:1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
          ],
          columnGap: 1,
          lineHeight: 1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
          ],
          columnGap: 1,
          lineHeight: 1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
          ],
          columnGap: 1,
          lineHeight: 1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
            { width: '50%',
              text: '............................................................................', style: 'bodyhead',
            },
          ],
          columnGap: 1,
          lineHeight: 1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            {
              width: '100%',
              style: 'normalCenter',
              text: 'ลงชื่อ ............................................................................ ผู้ซื้อ / ผู้สั่งจอง',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 32, 0, 0 ]
        },
        {
          columns: [
            { width: '27%',
              text: '', style: 'normalCenter',
            },
            { width: '50%', style: 'normal',
              text: ' (............................................................................) ',
            },
            { width: '23%',
              text: '', style: 'normalCenter',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 8, 0, 0 ]
        },
        {
          columns: [
            { width: '100%', style: 'normalCenter',
              text: 'ลงชื่อ ............................................................................ ผู้ขาย / ผู้รับจอง',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 16, 0, 0 ]
        },
        {
          columns: [
            { width: '27%',
              text: '', style: 'normalCenter',
            },
            { width: '50%', style: 'normal',
              text: ' (............................................................................) ',
            },
            { width: '23%',
              text: '', style: 'normalCenter',
            },
          ],
          columnGap: 0,
          lineHeight:1,
          margin: [ 0, 8, 0, 0 ]
        },
      ],//content
      styles: {
        normal: {
          fontSize: 16,
        },
        normalCenter: {
          fontSize: 16,
          alignment: 'center'
        },
        normalRight: {
          fontSize: 16,
          alignment: 'right'
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        titleLarge: {
          fontSize: 20,
          bold: true,
          alignment: 'center'
        },
        textNormal: {
          fontSize: 14,
        },
        textReserve: {
          fontSize: 14,
        },
        textProfile: {
          fontSize: 14,
          noWrap: false
        },
        tableCar: {
          margin: [0, 5, 0, 10]
        },
      },//styles
      defaultStyle: {
        font: 'THSarabunNew'
      }
    }//docDefinition

    pdfMake.createPdf(docDefinition).open();
  }

  printCarBookPdf(car_sell_pay, car, carLeasingList, carBook, profile){
    //const car_book_id = car_sell_pay.car_book_id;
    //const car_brance = this.state.car.branch_name
    //const car_brance_address = this.state.car.branch_address
    //const car_brance_tel = this.state.car.branch_tel
    const car_name = car.car_name //ยี่ห้อรถ
    //const car_color_name = this.state.car.car_color_name //สี
    const car_license_plate_new = car.car_license_plate_new //ทะเบียนรถยนต์
    const car_province_name_new = car.province_name_new//จังหวัด
    const car_explain = car.car_explain
    const car_sale_price = car.car_sale_price.toLocaleString()

    const customer_name = car_sell_pay.customer_name //ชื่อลูกค้า
    const customer_lastname = car_sell_pay.customer_lastname //นามสกุลลูกค้า
    const customer_address = car_sell_pay.customer_address //ที่อยู่ลูกค้า
    const customer_mobile = car_sell_pay.customer_mobile //
    const date_pay = moment(car_sell_pay.date_pay).locale('th').format('LL') //วันที่ออกใบเสร็จหรือวันที่จ่าย
    // const person_transaction = car_sell_pay.person_transaction //ผู้ออกใบเสร็จ
    // const car_sell_list_pay = car_sell_pay.car_sell_list_pay_name //รายการที่จ่าย
    // const sales_type = car_sell_pay.sales_type_name //รูปแบบการจ่าย
    // const car_sell_pay_count = '฿' + car_sell_pay.car_sell_pay_count.toLocaleString()  //ยอดเงิน
    // const bill_no = 'R'+car_book_id //this.refs.bill_no.value
    // const hostname = window.location.hostname
    // const car_upload_filename = car.car_upload_filename

    let base64Img = this.state.carBase64Img
    if (this.state.carBase64Img === '') {
      AlertWarning('กรุณารอสักครู่ระบบกำลังโหลดภาพรถ')
      return
    }

    /*var car_url = ''
    if (car.car_upload_filename.includes('https')) {
      car_url = car_upload_filename
    } else {
      car_url = 'https://'+hostname +'/'+ BASE_DIR+'/car_photos/thumb/'+car_upload_filename
    }*/

    var leasings = []

    var carDetail1 = [
      {
        colSpan: 4,
        border: [false, false, false, false],
        text: car_name ,
        style: 'textReserve'
      },'','',''
    ];
    var carDetail2 = [
      {
        colSpan: 4,
        border: [false, false, false, false],
        text: 'ทะเบียนรถ '+car_license_plate_new + ' '+ car_province_name_new ,
        style: 'textReserve'
      },'','',''
    ];
    var carDetail3 = [
      {
        colSpan: 4,
        border: [false, false, false, false],
        text: 'ราคา '+car_sale_price + ' บาท ('+ car_explain+')' ,
        style: 'textReserve'
      },'','',''
    ];

    var leasingHead = ['ธนาคาร', 'ราคากลาง' , 'เครดิต', 'ไม่เครดิต']

    leasings.push(carDetail1)
    leasings.push(carDetail2)
    leasings.push(carDetail3)
    leasings.push(leasingHead)

    carLeasingList.map(leasing => {
      let car_leasing_name = leasing.car_leasing_name
      let car_leasing_price_median = leasing.car_leasing_price_median
      let car_leasing_price = leasing.car_leasing_price
      let car_leasing_price_nc = leasing.car_leasing_price_nc
      let data = [car_leasing_name, car_leasing_price_median, car_leasing_price, car_leasing_price_nc] ;
      return leasings.push(data)
    })

    let discount = Number(car.car_sale_price) - Number(carBook.cost_car_book)
    let discount_price = discount > 0 ? discount : 0

    var carReserve = [];
    var datePay = [
      {
        border: [false, false, false, false],
        text: 'วันที่จอง ',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+date_pay,
        style: 'textReserve'
      }
    ];


    let cost_car_book = [
      {
        border: [false, false, false, false],
        text: 'ราคาขาย',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_car_book.toLocaleString(),
        style: 'textReserve'
      }
    ];

    //
    let car_discount = [
      {
        border: [false, false, false, false],
        text: 'ส่วนลด',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+discount_price.toLocaleString(),
        style: 'textReserve'
      }
    ]

    var cost_car_finance = [
      {
        border: [false, false, false, false],
        text: 'ราคาไฟแนนท์',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_car_finance.toLocaleString(),
        style: 'textReserve'
      }
    ];

    var cost_down = [
      {
        border: [false, false, false, false],
        text: 'เงินดาวน์รถ',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_down.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var cost_finance = [
      {
        border: [false, false, false, false],
        text: 'ค่าโอน+ค่าจัด',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_finance.toLocaleString(),
        style: 'textReserve'
      }
    ];
    /*
    ยกเลิก รวมกับ cost_finance
    var cost_check = [
      { border: [false, false, false, false],
        text: 'ค่าตรวจ+ค่าจัด'
      },{
        border: [false, false, false, false],
        text: '= '+carBook.cost_check.toLocaleString()
      }
    ];*/
    var cost_insurance = [
      {
        border: [false, false, false, false],
        text: 'ค่าประกันภัย',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_insurance.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var cost_car_tax = [
      {
        border: [false, false, false, false],
        text: 'ค่า พ.ร.บ./ภาษีรถ',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_car_tax.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var cost_car_out = [
      {
        border: [false, false, false, false],
        text: '*รวมเงินทั้งสิ้น',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_car_out.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var cost_pledge = [
      {
        border: [false, false, false, false],
        text: 'หัก : เงินมัดจำรถไว้',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_pledge.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var cost_car_out_remain = [
      {
        border: [false, false, false, false],
        text: 'ยอดที่ต้องชำระ ณ วันออกรถ',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.cost_car_out_remain.toLocaleString(),
        style: 'textReserve'
      }
    ];
    var booking_by = [
      {
        border: [false, false, false, false],
        text: 'ผู้รับจอง',
        style: 'textReserve'
      },
      {
        border: [false, false, false, false],
        text: '= '+carBook.booking_by,
        style: 'textReserve'
      }
    ];


    carReserve.push(datePay)
    carReserve.push(cost_car_book)
    carReserve.push(car_discount)
    carReserve.push(cost_car_finance)
    carReserve.push(cost_down)
    carReserve.push(cost_finance)
    // carReserve.push(cost_check)
    carReserve.push(cost_insurance)
    carReserve.push(cost_car_tax)
    carReserve.push(cost_car_out)
    carReserve.push(cost_pledge)
    carReserve.push(cost_car_out_remain)
    carReserve.push(booking_by)

    if(Object.keys(profile).length === 0){
      profile = {
        profile_from: '',
        profile_fn1: '',
        profile_fn2: '',
        profile_fn3: '',
        profile_name: '',
        profile_ncb1: '',
        profile_guarantor1: '',
        profile_guarantor_ncb1: '',
        profile_guarantor2: '',
        profile_guarantor_ncb2: '',
      }
    }

    var tableProfile = [];
    var profile_from = [
      {
        border: [false, false, false, false],
        text: 'จาก',
        style: 'textProfile'
      }, {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_from ,
        style: 'textProfile'
      },''
    ];
    // profile_address
    var profile_address = [
      {
        border: [false, false, false, false],
        text: 'ลูกค้ามาจาก: ',
        style: 'textProfile'
      }, {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_address ,
        style: 'textProfile'
      },''
    ];

    var profile_fn1 = [
      {
        border: [false, false, false, false],
        text: 'F/N : '+ Object.keys(profile).length === 0 ? ' ': profile.profile_fn1,
        style: 'textProfile'
      },
      {
        border: [false, false, false, false],
        text: 'F/N : '+ Object.keys(profile).length === 0 ? ' ': profile.profile_fn2,
        style: 'textProfile'
      },
      {
        border: [false, false, false, false],
        text: 'F/N : '+ Object.keys(profile).length === 0 ? ' ': profile.profile_fn3,
        style: 'textProfile'
      },
    ];
    var profile_name = [
      {
        border: [false, false, false, false],
        text: 'PROFILE: ',
        style: 'textProfile'
      }, {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_name,
        style: 'textProfile'
      },''
    ];
    var profile_ncb1 = [
      {
        border: [false, false, false, false],
        text: 'NCB: ',
        style: 'textProfile'
      },
      {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_ncb1,
        style: 'textProfile'
      },''
    ];

    var profile_guarantor1 = [
      {
        border: [false, false, false, false],
        text: 'ค้ำ 1: ',
        style: 'textProfile'
      },
      {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+Object.keys(profile).length === 0 ? ' ': profile.profile_guarantor1,
        style: 'textProfile'
      },''
    ];

    var profile_guarantor_ncb1 = [
      {
        border: [false, false, false, false],
        text: 'ค้ำ1 NCB: ',
        style: 'textProfile'
      },
      {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_guarantor_ncb1,
        style: 'textProfile'
      },''
    ];

    var profile_guarantor2 = [
      {
        border: [false, false, false, false],
        text: 'ค้ำ 2: ',
        style: 'textProfile'
      },
      {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_guarantor2,
        style: 'textProfile'
      },''
    ];

    var profile_guarantor_ncb2 = [
      {
        border: [false, false, false, false],
        text: 'ค้ำ2 NCB: ',
        style: 'textProfile'
      },
      {
        colSpan: 2,
        border: [false, false, false, false],
        text: ''+ Object.keys(profile).length === 0 ? ' ': profile.profile_guarantor_ncb2,
        style: 'textProfile'
      },''
    ];


    tableProfile.push(profile_from)
    tableProfile.push(profile_address)
    tableProfile.push(profile_fn1)
    tableProfile.push(profile_name)
    tableProfile.push(profile_ncb1)
    tableProfile.push(profile_guarantor1)
    tableProfile.push(profile_guarantor_ncb1)
    tableProfile.push(profile_guarantor2)
    tableProfile.push(profile_guarantor_ncb2)

    // this.convertImgToBase64URL(car_url, function(base64Img){

     let docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [45, 30, 30, 25], // margin: [left, top, right, bottom]
      content: [
        { text: 'ใบจองรถ', style: 'bodyhead', lineHeight:1.3},
        {
          style: 'tableCar',
          table: {
            widths: ['16%','42%', '42%'],
            heights: [200],
            body: [
              [
                {
                  border: [false, false, false, false],
                  width: 75,
                  image: base64Img
                  //text: 'base64Img'
                }
                ,
                {
                  border: [false, false, false, false],
                  table: {
                    widths: ['25%', '25%', '25%', '25%'],
                    body: leasings
                  }
                }
               ,
                {
                border: [false, false, false, false],
                table: {
                  widths: ['50%','50%'],
                  body: carReserve
                }
               }],
            ]
          }
        },
        {
          style: 'tableCar',
          table: {
            body: [
              [{
                border: [false, false, false, false],
                text: 'ชื่อลูกค้า: '+customer_name+' '+ customer_lastname+ ' ('+ customer_mobile+')',
                style: 'textNormal'
              }],
              [{
                border: [false, false, false, false],
                text: 'ที่อยู่ลูกค้า: '+customer_address,
                style: 'textNormal'
              }]
            ]
          }
        },
        {
          style: 'tableCar',
          table: {
            heights: function (row) {
              // return (row + 1) * 25;
              return 35;
            },
            widths: [62,'auto','auto'],
            body: tableProfile
          }
        },
      ],//content
      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        textNormal: {
          fontSize: 14,
        },
        textReserve: {
          fontSize: 14,
        },
        textProfile: {
          fontSize: 14,
          noWrap: false
        },
        tableCar: {
          margin: [0, 5, 0, 10]
        },
      },//styles
      defaultStyle: {
        font: 'THSarabunNew'
      }
    }//docDefinition

     pdfMake.createPdf(docDefinition).open();
    // }); //end image

  }

  convertImgToBase64URL(url, callback){

    var img = new Image();
    // img.crossOrigin = 'anonymous';
    // img.crossOrigin = 'use-credentials';
    // img.crossOrigin = '*';
    img.allowTaint = true;
    img.onload = function(){
      let canvas = document.createElement('CANVAS')
      let  ctx = canvas.getContext('2d');
      let dataURL
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL('image/png');
      callback(dataURL);
      canvas = null;
    };
    img.src = url;
  }

  convertImgToBase64URLPromise(url, outputFormat) {
    return new Promise(function (fulfill, reject){
      const img = new Image();
      // img.crossOrigin = 'Anonymous';
      // img.allowTaint = true;
      img.crossOrigin = 'anonymous';
      // img.crossOrigin = 'http://localhost:3000';
      img.onload = function () {
        var canvas = document.createElement('CANVAS'),
          ctx = canvas.getContext('2d'), dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        // dataURL = canvas.toDataURL(outputFormat);
        dataURL = canvas.toDataURL(null);
        if (dataURL === null) {
          reject(null);
        } else {
          fulfill(dataURL);
        }
        canvas = null;
      };
      img.src = url;
    });
  }

  async addPayment(car_sell_pay_add) {
    await this.loadSalesTypeData()
    await this.loadBankData()
    await axios.get(APIURL + '/car_sell_list_pay/')
      .then(res => {
        this.setState({
          car_sell_list_pay: res.data,
          car_sell_pay_add: car_sell_pay_add
        }, ()=> {
          this.toggleAddPayment()
        })
      }).catch(error => {
        this.setState({car_sell_list_pay: []});
      })
  }

  toggleAddPayment() {
      this.setState({
        toggle_add_payment: !this.state.toggle_add_payment
      });
  }

  carSalesPayTypeChange (obj){
    let value = obj.target.value

    this.setState({sales_type_id: value}, ()=>{
      if (value === '1') {
        this.refs.bank_id.value = '1'
      } else {
        this.refs.bank_id.value = ''
      }
    });
  }

  async loadSalesTypeData () {
    await axios.get(APIURL + '/sales_type/')
      .then(res => {
        this.setState({sales_type: res.data})

      }).catch(error => {
        this.setState({sales_type: []})
      })
  }

  async loadBankData () {
    await axios.get(APIURL + '/bank/')
      .then(res => {
        this.setState({bank: res.data})

      }).catch(error => {
        this.setState({bank: []})
      })
  }

  handleCarSellPayAddSubmit(event) {
    event.preventDefault();

    let date_pay = event.target.date_pay.value
    let car_sell_list_pay_id = event.target.car_sell_list_pay_id.value
    let car_sell_pay_count = event.target.car_sell_pay_count.value // ยอดใหม่ที่กรอก
    let sales_type_id = event.target.sales_type_id.value
    let bank_id = event.target.bank_id.value
    let person_transaction = this.state.user.user
    let customer_id = this.state.car_sell_pay_add.customer_id
    let car_id = this.state.car_sell_pay_add.car_id

    let data = {
      car_id: car_id,
      customer_id: customer_id,
      date_pay: date_pay,
      car_sell_list_pay_id: car_sell_list_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      sales_type_id: sales_type_id,
      bank_id: bank_id,
      person_transaction: person_transaction,
      user_created: this.state.user.user,
      user_updated: this.state.user.user,
      car_sell_pay_tag: 'จ่ายเพิ่มเติม',
      car_book_id: this.state.car_sell_pay_add.car_book_id
    }

    //add การจ่ายเงินเพิ่มเติม
    axios.post(APIURL + '/car_sell_pay/book/', data)
      .then(res => {

        if (res.status === 200) {
          //load new pay list
          this.setState({
            toggle_add_payment: !this.state.toggle_add_payment
          },()=>{
            this.loadCarBook();
            // this.loadDataCarSellPay()
          });
        }

      })
      .catch(function (error) {
        console.log(error)
        alert('พบข้อผิดพลาด: ' + error)
      })

  }

  handleUploadFile (event){
    const car_book = this.state.car_sell_pay_selected
    const input_file_name = event.target.name
    // let slip_key = input_file_name === 'slip_image1' ? this.state.slip_key1 : this.state.slip_key2
    let slip_key = ''

    const that = this;
    const car_book_id = car_book.car_book_id

    // input_file_name= slip_image2
    if (input_file_name === 'slip_image1'){
      slip_key = this.state.slip_key1 === null ? '' : this.state.slip_key1
      this.refs.img_slip_image1.src='img/loading.gif'
      this.refs.img_slip_image1.height=32
    } else if (input_file_name === 'slip_image2') {
      slip_key = this.state.slip_key2 === null ? '' : this.state.slip_key2
      this.refs.img_slip_image2.src='img/loading.gif'
      this.refs.img_slip_image2.height=32
    }

    const data = new FormData();
    data.append('uploads', event.target.files[0], event.target.files[0].name)
    data.append('car_book_id', car_book_id)
    data.append('slip_key', slip_key)
    data.append('slip_image', input_file_name)

    axios.put(APIURL+'/car_book/slip/'+car_book_id, data).then(function(res) {
      const resData = res.data;
      const filename = resData.image;
      const slip_key = resData.slip_key;
      let image_url = ''

      if(resData.image === undefined) {
        image_url = IMAGE_UPLOAD_ERROR
      } else if (resData.image === 'uploaderror') {
        image_url = IMAGE_UPLOAD_ERROR
      } else {
        image_url = filename
      }

      if( input_file_name === 'slip_image1'){
        that.setState({
          slip_image1: image_url,
          slip_key1: slip_key
        })
      } else if (input_file_name === 'slip_image2') {
        that.setState({
          slip_image2: image_url,
          slip_key2: slip_key
        })
      }

    })

  }

  onPreviewSelected(url){
    this.setState({
      preview_image_url: url,
      preview_image_select: true
    });
  }

  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select
    });
  }

  saveBookNumber() {
     let book_number = this.state.book_number
     let volume_number = this.state.volume_number
     let car_sell_pay = this.state.car_sell_pay_selected
     let car_book_id = car_sell_pay.car_book_id

    if(car_sell_pay.book_number === null && car_sell_pay.volume_number === null ) {
      // update จาก null
      console.log('update จาก null car_book_id', car_book_id)
      this.updateBookNumber(car_book_id, book_number, volume_number);
    } else if (car_sell_pay.book_number !== book_number || car_sell_pay.volume_number !== volume_number) {
      // มีการ เปลี่ยนค่า
      console.log('updateมีการ เปลี่ยนค่า car_book_id', car_book_id)
      this.updateBookNumber(car_book_id, book_number, volume_number);
    }

    car_sell_pay = {...car_sell_pay, book_number: book_number, volume_number: volume_number}

    this.printOcpb(car_sell_pay)
    this.togglePrintBill()
  }

  updateBookNumber(car_book_id, book_number, volume_number) {
    // car_book/book_number
    let api = APIURL+ '/car_book/book_number'
    let data = {
      car_book_id: car_book_id,
      book_number: book_number,
      volume_number: volume_number
    }
    axios.put(api, data).then(res => {
      console.log(res.data)
      this.loadCarBook();
    }).catch(err => {
      console.log('error:', err)
    })
  }

  render () {

    let car = this.state.car
    let width = this.state.width

    let car_sell_pay_tr = this.state.car_book_list.map((car_sell_pay, index) => {

      let car_book_status_id = car_sell_pay.car_book_status_id
      let car_sell_pay_refund = car_sell_pay.car_sell_pay_refund
      let car_sell_pay_tag = car_sell_pay.car_sell_pay_tag
      let car_book_id = car_sell_pay.car_book_id
      let book_number = car_sell_pay.book_number === '' ? 'R'+car_book_id : car_sell_pay.book_number
      let volume_number = car_sell_pay.volume_number

      return (
        <tr key={index}>
          <td
            className="text-left"
          >

            {
              book_number === null ? <span className="text-danger">เลขการจอง: {car_book_id}</span> : (
                <>
                <span className="text-danger">เล่มที่ : {volume_number}</span> <br/>
                <span className="text-success">เลขที่ใบจอง : {book_number}</span>
                </>
              )
            }
            <br/>
            วันที่จอง : {moment(car_sell_pay.date_pay).locale('th').format('LL')}


          </td>
          <td className="text-center">
            {car_sell_pay.customer_name}&nbsp;&nbsp;{car_sell_pay.customer_lastname}<br/>
            <span
              className={car_sell_pay.car_book_status_id === 1 ?  car_sell_pay_tag===null ?
                'badge badge-success' : 'badge badge-primary' : 'badge badge-danger' }
            >
                {car_sell_pay.car_book_status_id === 1 ? car_sell_pay_tag===null ? 'จอง' : car_sell_pay_tag : ' ยกเลิกการจอง' }
            </span>

            {
              car_sell_pay.book_comment === null ? null : (
                <>
                  <hr/>
                  หมายเหตุการจอง :
                  <br/>
                </>
              )
            }

            {
              car_sell_pay.book_comment === null ? null : parse(car_sell_pay.book_comment)
            }

            <hr/>
            {
              car_sell_pay.booking_by === null ? null : (
                  <>
                    ผู้รับจอง : {car_sell_pay.booking_by === null ? null : car_sell_pay.booking_by}
                  </>
              )
            }



          </td>
          <td className="text-center">
            {car_sell_pay.car_sell_list_pay_name}

            {
              car_sell_pay.slip_image1 === null ? null : (
                <>
                  <br/>
                  <br/>
                  <label htmlFor="name">
                  <a rel="noopener noreferrer"
                     href={car_sell_pay.slip_image1}
                     target="_blank"
                     onClick={(e)=>this.saveCarImage(e, car_sell_pay.slip_image1)}
                     className={car_sell_pay.slip_image1===null? 'hidden' : ''}>
                    <span>donwload</span>
                  </a>
                  </label>
                  <br/>
                <img
                  src={car_sell_pay.slip_image1}
                  style={{'cursor' : 'pointer', 'width': '120px', 'height': 'auto'}}
                  onClick={()=>this.onPreviewSelected(car_sell_pay.slip_image1)}
                  alt="เอกสาร 1"
                />
                </>
              )
            }

          </td>
          <td className="text-center">
            <NumberFormat value={car_sell_pay.car_sell_pay_count}
                          displayType={'text'}
                          thousandSeparator={true} prefix={'฿'}
            />

            {car_book_status_id === 1 && car_sell_pay_tag===null ? '/คืนเงิน ': '' }

            {car_book_status_id === 1 && car_sell_pay_tag===null ?  <NumberFormat value={car_sell_pay_refund} displayType={'text'} thousandSeparator={true} prefix={'฿'}/> : '' }

            {
              car_sell_pay.slip_image2 === null ? null : (
                <>
                  <br/>
                  <br/>
                  <label htmlFor="name">
                    <a rel="noopener noreferrer"
                       href={car_sell_pay.slip_image2}
                       target="_blank"
                       onClick={(e)=>this.saveCarImage(e, car_sell_pay.slip_image2)}
                       className={car_sell_pay.slip_image2===null? 'hidden' : ''}>
                      <span>donwload</span>
                    </a>
                  </label>
                  <br/>
                  <img
                    src={car_sell_pay.slip_image2}
                    style={{'cursor' : 'pointer', 'width': '120px', 'height': 'auto'}}
                    onClick={()=>this.onPreviewSelected(car_sell_pay.slip_image2)}
                    alt="เอกสาร 2"
                  />
                </>
              )
            }

          </td>
          <td className="text-center">{car_sell_pay.sales_type_name}</td>
          <td className="text-center">
            {car_sell_pay.bank_name}
          </td>
          <td className="text-center">
            {/*{car_sell_pay.person_transaction}*/}
            {car_sell_pay.book_by} <br/>
            เมื่อ: {moment(car_sell_pay.book_date).locale('th').format('LL')}

          </td>
          <td className={car_book_status_id === 1 && car_sell_pay_tag===null ? 'text-center' : 'hidden'}>

            <button onClick={() => {
              // TODO:: แนบสลิป
              this.setState({
                car_sell_pay_selected: car_sell_pay,
                slip_image1: car_sell_pay.slip_image1 === null ? IMAGE_NOPHOTO_URL: car_sell_pay.slip_image1,
                slip_image2: car_sell_pay.slip_image2 === null ? IMAGE_NOPHOTO_URL: car_sell_pay.slip_image2,
                slip_key1: car_sell_pay.slip_key1,
                slip_key2: car_sell_pay.slip_key2,
              },() => {
                this.toggleSlip()
              })
            }}
              type="button" className="btn btn-success btn-sm btn-block">
              <i className="icon-wallet">&nbsp;แนบสลิป</i>
            </button>

            <button
              type="button"
              className="btn btn-info btn-sm btn-block"
              onClick={() => this.addPayment(car_sell_pay)}
            >
              <i className="icon-plus">&nbsp;เพิ่มการชำระเงิน</i>
            </button>

            {
              port === '9021' && this.state.user.type === 'sale' ? null : (
                <button
                  onClick={() => {
                    this.setState({
                      book_status: 'edit',
                      car_sell_pay_selected: car_sell_pay
                    },() => {
                      this.toggleCarBookPrimary();
                    });
                  }}
                  type="button"
                  className="btn btn-warning btn-sm btn-block"
                >
                  <i className="icon-pencil">&nbsp;แก้ไขการจอง</i>
                </button>
              )
            }

            <button onClick={() => this.printCarBookCustomer(car_sell_pay)}
                    type="button" className="btn btn-success btn-sm btn-block">
              <i className="icon-printer">&nbsp;ใบจองลูกค้า</i>
            </button>

            <button onClick={() => this.printCarBook(car_sell_pay)}
                    type="button" className="btn btn-primary btn-sm btn-block">
              <i className="icon-printer">&nbsp;ใบจองเต็นท์</i>
            </button>

            <button onClick={() => {
                // TODO:: กรอกเลขใบเสร็จก่อนพิมพ์
                let book_number = car_sell_pay.book_number === null ? '' : car_sell_pay.book_number
                let volume_number = car_sell_pay.volume_number === null ? '' : car_sell_pay.volume_number
                this.setState({
                    car_sell_pay_selected: car_sell_pay,
                    book_number: book_number,
                    volume_number: volume_number
                },() => {
                   this.togglePrintBill()
                })

               //
               // this.printOcpb(car_sell_pay);
            }}
                    type="button" className="btn btn-success btn-sm btn-block">
              <i className="icon-printer">&nbsp;พิมพ์ใบเสร็จ</i>
            </button>

            {
              port === '9021' && this.state.user.type === 'sale' ? null : (
                <>
                  <button onClick={() => {
                    this.refundCarBook(car_sell_pay)
                  }}
                          type="button" className="btn btn-warning btn-sm btn-block">
                    <i className="icon-wallet">&nbsp;คืนเงินจอง</i>
                  </button>

                  <button onClick={() => {
                    this.deleteCarBook(car_sell_pay)
                  }}
                          type="button" className="btn btn-danger btn-sm btn-block">
                    <i className="icon-close">&nbsp;ยกเลิกจอง</i>
                  </button>
                </>
              )
            }

          </td>
          <td className={car_book_status_id === 1 && car_sell_pay_tag!==null ? 'text-center' : 'hidden'}>

            <button onClick={() => {
              //TODO:: กรอกเลขใบเสร็จก่อนพิมพ์
              // this.setState({car_sell_pay_selected: car_sell_pay},() => {
              // this.togglePrintBill()
              // })
              this.printOcpb(car_sell_pay);
            }}
                    type="button" className="btn btn-success btn-sm btn-block">
              <i className="icon-printer">&nbsp;พิมพ์ใบเสร็จ</i>
            </button>

            <button onClick={() => {
              this.deleteCarBookPayAddition(car_sell_pay)
            }}
                    type="button" className="btn btn-danger btn-sm btn-block">
              <i className="icon-trash">&nbsp;ลบรายการ</i>
            </button>

          </td>
          <td className={car_book_status_id === 1 ? 'hidden ' : 'text-center'}>
            <i className="icon-close"></i>
          </td>

        </tr>
      )
    });

    var car_sell_list_pay_list = this.state.car_sell_list_pay.map((car_sell_list_pay, index) => {
      return (
        <option key={index}
                value={car_sell_list_pay.car_sell_list_pay_id}
        >
          {car_sell_list_pay.car_sell_list_pay_name}
        </option>
      )
    });

    var sales_type_list = this.state.sales_type.map((sales_type, index) => {
      return (
        <option key={index} value={sales_type.sales_type_id}>{sales_type.sales_type_name}</option>
      )
    });

    var bank_pay_list = this.state.bank.map((bank, index) => {
      return (
        <option key={index} value={bank.bank_id}>{bank.bank_name}</option>
      )
    });

    return (

      <div className="card">

        <Modal isOpen={this.state.refund} toggle={this.toggleRefund.bind(this)}
               className={'modal-danger'}>
          <ModalHeader toggle={this.toggleRefund.bind(this)}>คืนเงินจอง</ModalHeader>
          <ModalBody>
            <div className="card-block">
              <div className="row">
                <div className="row p-5">
                  <div className="form-group col-sm-6">
                    <strong>ยอดเงินที่ชำระ :</strong>
                  </div>
                  <div className="form-group col-sm-6">
                    <input type="text" className="form-control"
                           ref="car_sell_pay_count"
                           value={this.state.car_sell_pay_count}
                           onChange={() => {}}
                    />
                  </div>

                  <div className="form-group col-sm-6">
                    <strong>ยอดคืนเงิน :</strong>
                  </div>

                  <div className="form-group col-sm-6">
                    <input type="text"
                           className="form-control hidden"
                           name="car_book_refund"
                           placeholder=""
                           ref="car_book_refund"
                           value={this.state.car_book_refund}
                           onChange={() => {}}
                    />
                      <NumberFormat
                        className="form-control"
                        thousandSeparator={true}
                        prefix={'฿'}
                        placeholder="คืนเงิน"
                        min={0}
                        max={1000000000}
                        step={1000}
                        size={10}
                        allowNegative={false}
                        onValueChange={(values) => {
                          const {value} = values;
                          this.setState({car_book_refund: value});
                        }}
                      />
                  </div>

                </div>
              </div>
            </div>

          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggleRefund.bind(this)}>ยกเลิก</Button>
            <Button color="primary"
                    onClick={this.carBookCancelRefund.bind(this)}>ตกลง</Button>{' '}

          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.danger} toggle={this.toggleDanger.bind(this)}
               className={'modal-danger'}>
          <ModalHeader toggle={this.toggleDanger.bind(this)}>ยกเลิกการจอง</ModalHeader>
          <ModalBody>
            <strong> คุณต้องยกเลิกการจอง {this.state.car_sell_pay_selected.customer_name} ใช่หรือไม่ ?? </strong>
            <br />(ข้อมูลจะไม่สามารถกู้คืนได้)
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggleDanger.bind(this)}>ยกเลิก</Button>
            <Button color="primary"
                    onClick={()=>{
                      this.carBookCancel(this.state.car_book_id)
                    }}>ตกลง</Button>{' '}
          </ModalFooter>
        </Modal>

        <Modal className="modal-lg modal-dialog" isOpen={this.state.toggle_bill_print} toggle={this.togglePrintBill}>
          <ModalBody>
            <div id="divToPrint"  >
              <div className="row">
                <div className="col-md-12 text-center">
                  <strong>เพิ่มข้อมูลใบจอง</strong>
                </div>
              </div>

              <div className="row pt-5">

                <div className="form-group col-sm-2">
                </div>
                <div className="form-group col-sm-3">
                  <strong>เล่มที่ :</strong>
                </div>
                <div className="form-group col-sm-6">
                  <input type="text"
                         name="volume_number"
                         maxLength={10}
                         value={this.state.volume_number}
                         onChange={(e) => {
                           this.setState({
                             volume_number: e.target.value
                           })
                         }}
                  />
                </div>
              </div>

              <div className="row">

                <div className="form-group col-sm-2">
                </div>
                <div className="form-group col-sm-3">
                  <strong>เลขที่ใบเสร็จ :</strong>
                </div>
                <div className="form-group col-sm-6">
                  <input type="text"
                         name="book_number"
                         maxLength={20}
                         value={this.state.book_number}
                         onChange={(e) => {
                           this.setState({
                             book_number: e.target.value
                           })
                         }}
                  />
                </div>
              </div>

            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={()=> this.saveBookNumber()} >พิมพ์ใบเสร็จ</Button>{' '}
            <Button color="secondary" onClick={this.togglePrintBill}>ยกเลิก</Button>
          </ModalFooter>
        </Modal>

        <Modal className="modal-lg modal-dialog" isOpen={this.state.toggle_slip} toggle={this.toggleSlip}>
          <ModalHeader toggle={this.toggleSlip.bind(this)}>แนบสลิป</ModalHeader>
          <ModalBody>
              <div className="row p-5">
                <div className="form-group col-sm-1">
                </div>

                <div className="form-group col-sm-5">
                  <label htmlFor="name">1) เอกสาร 1
                    &nbsp;
                    <a rel="noopener noreferrer"
                       href={this.state.slip_image1}
                       target="_blank"
                       onClick={(e)=>this.saveCarImage(e,this.state.slip_image1)}
                       className={this.state.slip_image1===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                      <span>donwload</span>
                    </a>
                  </label>
                  <div style={styles.fileInputWrapper} >

                    <button style={styles.btnFileInput}>
                      <img src={this.state.slip_image1}
                           style={styles.btnFileInputImage}
                           ref="img_slip_image1"
                           alt="เอกสาร 1"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file"
                      name="slip_image1"
                      onChange={this.handleUploadFile}
                    />
                  </div>

                </div>

                <div className="form-group col-sm-5">
                  <label htmlFor="name">2) เอกสาร 2
                    &nbsp;
                    <a rel="noopener noreferrer"
                       href={this.state.slip_image2}
                       target="_blank"
                       onClick={(e)=>this.saveCarImage(e,this.state.slip_image2)}
                       className={this.state.slip_image2===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                      <span>donwload</span>
                    </a>
                  </label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.slip_image2}
                           style={styles.btnFileInputImage}
                           ref="img_slip_image2"
                           alt="เอกสาร 2"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file"
                      name="slip_image2"
                      onChange={this.handleUploadFile}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-1">
                </div>
              </div>
          </ModalBody>
          <ModalFooter>
            {/*<Button color="primary" onClick={()=>{
            }}>
               xxx
            </Button>*/}
            {' '}
            <Button color="secondary" onClick={() => {
              // TODO: reload car_book
              this.loadCarBook();
              this.toggleSlip();

            }}>ยกเลิก</Button>
          </ModalFooter>
        </Modal>



        <div className="card-block">
          {/*<form action="" method="post" onSubmit={this.handleOnSubmitCarBook}>*/}
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">เพิ่มรายละเอียดการจองรถ</strong>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 ">
                            <strong> ชื่อรถ </strong></label>
                          <div className="col-md-10">
                            <p className="text-justify text-primary">
                              <strong> {car.car_name} </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2"><strong> ยี่ห้อ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_brand_name} </strong></p>
                          </div>

                          <label className="col-md-2 "><strong> รุ่นรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_model_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> รุ่นย่อย </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_sub_model_name} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2"><strong> ปีรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_year_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> ระบบเกียร์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_gear_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> สีรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_color_name} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2"><strong> เลขไมล์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_miles} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> ป้ายทะเบียนรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.car_license_plate_new} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> จังหวัด </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car.province_name_new} </strong></p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header">

                    <strong className="text-title">ข้อมูลการจอง</strong>

                    <button type="button" onClick={()=>{
                      this.setState({
                        book_status: 'add'
                      },() => this.toggleCarBookPrimary())
                    }}
                      className="btn btn-info float-right">
                      <i className="icon-plus"/>&nbsp;เพิ่มการจองรถ
                    </button>

                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-lg-12">
                        <table className="table table-bordered table-striped table-md">
                          <thead>
                          <tr>
                            <th className="text-center" width="16%">วันที่</th>
                            <th className="text-center" width="20%">ผู้จอง</th>
                            <th className="text-center" width="15%">รายการ</th>
                            <th className="text-center" width="15%">ยอดเงินที่ชำระ</th>
                            <th className="text-center" width="17%">ประเภทการชำระ</th>
                            <th className="text-center" width="18%">ธนาคาร</th>
                            <th className="text-center" width="21%">ผู้บันทึกรายการ</th>
                            <th className="text-center" width="13%">จัดการ</th>
                          </tr>
                          </thead>
                          <tbody>
                          {car_sell_pay_tr}
                          <tr
                            className={(this.state.car_book_list.length === 0) ? 'text-center' : ' hidden'}>
                            <td colSpan="8">
                              <span className="text-danger"> ไม่พบข้อมูลการจอง </span>
                            </td>
                          </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          {/*</form>*/}

          <Modal isOpen={this.state.preview_image_select} toggle={this.togglePreviewImage} className={'modal-lg '}>
            <ModalBody>
              <PreviewImage
                imageUrl={this.state.preview_image_url}
              />
            </ModalBody>
          </Modal>

          <Modal isOpen={this.state.carbookprimary}
                 toggle={this.toggleCarBookPrimary}
                 className="modal-book-lg"
                 backdrop={'static'}
                 style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
          >
            <ModalBody>
              <CarBookForm
                car_id={this.state.car_id}
                car={car}
                onLoadCarBook={this.loadCarBook}
                onToggle={this.toggleCarBookPrimary}
                //for edit
                book_status={this.state.book_status}
                car_sell_pay_selected={this.state.car_sell_pay_selected}
              />
            </ModalBody>
          </Modal>

          <Modal
            isOpen={this.state.toggle_add_payment}
            toggle={this.toggleAddPayment}
            className="modal-lg"
            backdrop={'static'}
          >
            <ModalBody>
              <form
                action="" method="post"
                onSubmit={ this.handleCarSellPayAddSubmit }
              >

                <div className="card card-accent-warning">
                  <div className="card-header card-sparepart">
                    <strong className="text-title">เพิ่มการชำระเงิน</strong>
                  </div>
                  <div className="card-block">
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label htmlFor="date_pay">วันที่ชำระเงิน </label>
                        <br />
                        <DatePicker
                          selected={this.state.date_pay}
                          onChange={this.handleDatePayAdd}
                          dateFormat="YYYY-MM-dd"
                          type="text"
                          className="form-control"
                          id="date_pay"
                          name="date_pay"
                          placeholder="วันที่ชำระเงิน"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="car_repair_complete">รายการ </label>
                        <select
                          className="form-control"
                          id="car_sell_list_pay_id"
                          ref="car_sell_list_pay_id"
                          value={this.state.car_sell_list_pay_id}
                          onChange={(e)=>{
                            const { target } = e
                            this.setState({
                              car_sell_list_pay_id: target.value
                            });
                          }}
                        >
                          <option value=''>เลือกรายการ</option>
                          {car_sell_list_pay_list}
                        </select>

                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-md-6">
                        <label htmlFor="car_sell_pay_count">จำนวนเงินที่ชำระ </label>
                        <input type="text"
                               className="form-control hidden"
                               id="car_sell_pay_count"
                               name="car_sell_pay_count"
                               placeholder=""
                               ref="car_sell_pay_count"
                               value={this.state.car_sell_pay_count}
                               onChange={()=>{}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={'฿'}
                          //placeholder="กรอกค่าโอน"
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          value={this.state.car_sell_pay_count}
                          onValueChange={(values) => {
                            const {value} = values
                            this.setState({car_sell_pay_count: value}, () => {
                            })
                          }}
                        />

                        <input type="text hidden"
                               className="form-control hidden"
                               id="car_sell_pay_count_old"
                               name="car_sell_pay_count_old"
                               placeholder=""
                               ref="car_sell_pay_count_old"
                               value={this.state.car_sell_pay_count_old}
                               onChange={()=>{}}
                        />

                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="car_sell_pay_count">ประเภทการชำระ </label>
                        <select
                          className="form-control"
                          id="sales_type_id"
                          ref="sales_type_id"
                          value={this.state.sales_type_id}
                          onChange={this.carSalesPayTypeChange.bind(this)}
                        >
                          <option value=''>เลือกประเภทการรับชำระ</option>
                          {sales_type_list}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-md-6">
                        <label htmlFor="bank_id">ธนาคาร </label>
                        <select
                          className="form-control"
                          id="bank_id"
                          name="bank_id"
                          ref="bank_id"
                          value={this.state.bank_id}
                          onChange={(e)=>{
                            const { target } = e
                            this.setState({
                              bank_id: target.value
                            });
                          }}
                        >
                          <option value=''>เลือกธนาคาร</option>
                          {bank_pay_list}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer text-right">
                    <button type="reset"
                            onClick={()=>{
                              this.setState({
                                toggle_add_payment: false
                              });
                            }}
                            className="btn btn-sm btn-danger mr-2">
                      <i className="fa fa-refresh"/> ยกเลิก
                    </button>

                    <button type="submit"
                            className="btn btn-sm btn-primary">
                      <i className="fa fa-plus"/> เพิ่มชำระเงิน
                    </button>

                    <input type="hidden" id="car_sell_pay_id" name="car_sell_pay_id" value={this.state.car_sell_pay_id}/>

                  </div>
                </div>

              </form>
            </ModalBody>
          </Modal>


        </div>

      </div>
    )
  }
}

const styles = {
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
  },
  fileInputWrapper: {
    position: 'relative',
    overflow: 'hidden',
    height: 180,
    width: 200,
  },
  btnFileInput: {
    height: 180,
    width: 200,
    display: 'inline-block',
    backgroundColor: "#D2DDE2",
    backgroundImage: "linear-gradient(to bottom, #D2DDE2, #FCF8FF)",
    backgroundRepeat: "repeat-x",
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)"
  },
  btnFileInputImage:{
    position: 'absolute',
    top: 0,
    left: 0,
    height: 180,
    width: 200,
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    height: 180,
    width: 200,
    cursor: 'pointer'
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarBook)